import BaseLibraryIconSvg from '../../../../../components/Icon/BaseLibraryIconSvg';
import { IconSvgProps } from '../../../../../components/Icon/Icon';

const EmptyCircle = (props: IconSvgProps) => {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M11.9957 22C17.4667 22 22 17.4734 22 12C22 6.52659 17.458 2 11.9869 2C6.5207 2 2 6.52659 2 12C2 17.4734 6.52941 22 11.9957 22ZM11.9957 20.5272C7.27809 20.5272 3.48562 16.7283 3.48562 12C3.48562 7.27167 7.26938 3.47276 11.9869 3.47276C16.7132 3.47276 20.5192 7.27167 20.5192 12C20.5192 16.7283 16.7219 20.5272 11.9957 20.5272Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
};

export default EmptyCircle;
